import { render, staticRenderFns } from "./jiancha-select.vue?vue&type=template&id=be470bc2&scoped=true&"
import script from "./jiancha-select.vue?vue&type=script&lang=ts&"
export * from "./jiancha-select.vue?vue&type=script&lang=ts&"
import style0 from "./jiancha-select.vue?vue&type=style&index=0&id=be470bc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be470bc2",
  null
  
)

export default component.exports